

/**
 * @name AddCollectorController
 * @description Controller for adding collectors.
 * @param {Unknown} _ Lodash
 * @param {Unknown} $log Angular log service
 */
function AddCollectorController(
  _,
  $log
) {
}

angular
  .module('inkfinder')
  .controller('AddCollectorController', AddCollectorController);



// WEBPACK FOOTER //
// ./components/collector/add/add-collector.controller.js